// src/pages/CognitiveEvolutionHome.jsx

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBrain,
  faChartLine,
  faProjectDiagram,
  faClock,
  faBullseye,
  faLightbulb,
  faBalanceScale,
  faFire,
} from "@fortawesome/free-solid-svg-icons";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  RadialLinearScale,
  RadarController,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  RadialLinearScale,
  RadarController,
  Tooltip,
  Legend,
  Filler
);

import { Line, Radar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  RadarController,
  RadialLinearScale,
  Tooltip,
  Legend,
  Filler
);

const CognitiveEvolutionHome = () => {

  const evolutionData = {
    labels: [
      "Week 1",
      "Week 2",
      "Week 3",
      "Week 4",
      "Week 5",
      "Week 6",
    ],
    datasets: [
      {
        label: "Cognitive Maturity",
        data: [18, 28, 41, 57, 73, 88],
        borderColor: "#22d3ee",
        backgroundColor: "rgba(34,211,238,0.12)",
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const radarData = {
    labels: [
      "Reasoning",
      "Reflection",
      "Decision Quality",
      "Focus",
      "Adaptability",
      "Systems Thinking",
    ],
    datasets: [
      {
        label: "Current Cognitive Profile",
        data: [82, 69, 77, 73, 80, 88],
        backgroundColor: "rgba(34,211,238,0.18)",
        borderColor: "#22d3ee",
        borderWidth: 2,
      },
    ],
  };

  const evolutionCards = [
    {
      title: "Thinking Depth",
      value: "88%",
      icon: <FontAwesomeIcon icon={faBrain} />,
    },
    {
      title: "Reasoning Stability",
      value: "74%",
      icon: <FontAwesomeIcon icon={faBalanceScale} />,
    },
    {
      title: "Focus Consistency",
      value: "69%",
      icon: <FontAwesomeIcon icon={faClock} />,
    },
    {
      title: "Adaptive Growth",
      value: "+42%",
      icon: <FontAwesomeIcon icon={faChartLine} />,
    },
  ];

  return (
    <div className="min-h-screen bg-black text-cyan-100 px-3 py-4">

      {/* HEADER */}
      <div className="mb-4">
        <div className="text-xl font-bold text-cyan-300 tracking-wide">
          📈 Cognitive Evolution
        </div>

        <div className="text-xs text-cyan-500 mt-1">
          Think5Whys Cognitive Intelligence Layer
        </div>
      </div>

      {/* KPI BLOCKS */}
      <div className="grid grid-cols-2 gap-2 mb-4">

        {evolutionCards.map((item, idx) => (
          <div
            key={idx}
            className="bg-cyan-950/40 border border-cyan-900 rounded-xl p-3"
          >

            <div className="flex items-center justify-between">
              <div className="text-cyan-300 text-lg">
                {item.icon}
              </div>

              <div className="text-lg font-bold text-yellow-200">
                {item.value}
              </div>
            </div>

            <div className="mt-2 text-[11px] text-cyan-100">
              {item.title}
            </div>

          </div>
        ))}

      </div>

      {/* EVOLUTION GRAPH */}
      <div className="bg-cyan-950/30 border border-cyan-900 rounded-2xl p-3 mb-4">

        <div className="flex items-center gap-2 mb-3">
          <FontAwesomeIcon icon={faChartLine} className="text-cyan-300" />

          <div className="text-sm font-semibold text-cyan-200">
            Cognitive Growth Curve
          </div>
        </div>

        <Line
          data={evolutionData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                labels: {
                  color: "#cbd5e1",
                },
              },
            },
            scales: {
              x: {
                ticks: {
                  color: "#94a3b8",
                },
                grid: {
                  color: "rgba(255,255,255,0.05)",
                },
              },
              y: {
                ticks: {
                  color: "#94a3b8",
                },
                grid: {
                  color: "rgba(255,255,255,0.05)",
                },
              },
            },
          }}
        />

      </div>

      {/* RADAR PROFILE */}
      <div className="bg-cyan-950/30 border border-cyan-900 rounded-2xl p-3 mb-4">

        <div className="flex items-center gap-2 mb-4">
          <FontAwesomeIcon icon={faProjectDiagram} className="text-cyan-300" />

          <div className="text-sm font-semibold text-cyan-200">
            Cognitive Profile Mapping
          </div>
        </div>

        <div className="max-w-[320px] mx-auto">

          <Radar
            data={radarData}
            options={{
              responsive: true,
              scales: {
                r: {
                  angleLines: {
                    color: "rgba(255,255,255,0.08)",
                  },
                  grid: {
                    color: "rgba(255,255,255,0.08)",
                  },
                  pointLabels: {
                    color: "#cbd5e1",
                    font: {
                      size: 10,
                    },
                  },
                  ticks: {
                    color: "#94a3b8",
                    backdropColor: "transparent",
                  },
                },
              },
              plugins: {
                legend: {
                  labels: {
                    color: "#cbd5e1",
                  },
                },
              },
            }}
          />

        </div>

      </div>

      {/* EVOLUTION TIMELINE */}
      <div className="bg-cyan-950/30 border border-cyan-900 rounded-2xl p-3 mb-4">

        <div className="flex items-center gap-2 mb-4">
          <FontAwesomeIcon icon={faFire} className="text-yellow-300" />

          <div className="text-sm font-semibold text-cyan-200">
            Cognitive Evolution Timeline
          </div>
        </div>

        <div className="space-y-3 text-xs">

          <div className="border-l-2 border-cyan-500 pl-3">
            <div className="text-yellow-200">
              Week 1
            </div>

            <div className="text-cyan-100">
              Reactive decision behavior observed.
            </div>
          </div>

          <div className="border-l-2 border-cyan-500 pl-3">
            <div className="text-yellow-200">
              Week 3
            </div>

            <div className="text-cyan-100">
              Structured reasoning patterns emerging.
            </div>
          </div>

          <div className="border-l-2 border-cyan-500 pl-3">
            <div className="text-yellow-200">
              Week 5
            </div>

            <div className="text-cyan-100">
              Significant improvement in ambiguity handling.
            </div>
          </div>

          <div className="border-l-2 border-cyan-500 pl-3">
            <div className="text-yellow-200">
              Week 6
            </div>

            <div className="text-cyan-100">
              Systems-thinking capability detected consistently.
            </div>
          </div>

        </div>

      </div>

      {/* AI INSIGHT */}
      <div className="bg-cyan-950/30 border border-cyan-900 rounded-2xl p-3 mb-4">

        <div className="flex items-center gap-2 mb-3">
          <FontAwesomeIcon icon={faLightbulb} className="text-yellow-300" />

          <div className="text-sm font-semibold text-cyan-200">
            AI Cognitive Insights
          </div>
        </div>

        <div className="space-y-2">

          <div className="bg-black/40 border border-cyan-900 rounded-xl p-3 text-xs">
            Learner shows strong systems thinking but low reflection consistency.
          </div>

          <div className="bg-black/40 border border-cyan-900 rounded-xl p-3 text-xs">
            Decision confidence improved faster than decision accuracy.
          </div>

          <div className="bg-black/40 border border-cyan-900 rounded-xl p-3 text-xs">
            Cognitive fatigue patterns reduced after adaptive learning cycles.
          </div>

        </div>

      </div>

      {/* FINAL PANEL */}
      <div className="bg-gradient-to-r from-cyan-950/40 to-black border border-cyan-900 rounded-2xl p-4">

        <div className="flex items-center gap-2 mb-2">
          <FontAwesomeIcon icon={faBullseye} className="text-cyan-300" />

          <div className="text-sm font-semibold text-cyan-200">
            Strategic Cognitive Outcome
          </div>
        </div>

        <div className="text-xs leading-6 text-cyan-100">
          Think5Whys transforms learning from static training events into a continuously evolving intelligence system where reasoning quality,
          decision behavior, focus patterns, and cognitive maturity become measurable, improvable, and strategically valuable.
        </div>
      </div>
    </div>
  );
};

export default CognitiveEvolutionHome;